import template   from './product-details.html'
import controller from './product-details.controller'
import './product-details.styl'

let component = {
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/product-details/product-details.component.js